window.log = () => {};

if (process.env.NODE_ENV === 'development') {
  window.log = console.log;
}
